import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import OrganizationManager from "@/components/organization/OrganizationManager";
import { usePermissions } from "@/hooks/usePermissions";

export default function AgencyOrganizationTab() {
  const { can } = usePermissions();
  const { data: profile } = useQuery({
    queryKey: ["/api/user/profile"],
    queryFn: async () => {
      const r = await fetch("/api/user/profile");
      if (!r.ok) throw new Error("Failed to load profile");
      return r.json();
    },
  });

  // Use agencyId from profile (works for both brokers and agency members)
  const agencyId = (profile?.agencyId || "").toString();
  if (!agencyId) return null;

  const canEdit = can("agency:edit");

  return <OrganizationManager ownerType="agency" ownerId={agencyId} readOnly={!canEdit} />;
}
